export function objToStrMap<T>(obj: { [x: string]: T }) {
  const strMap = new Map<string, T>();
  for (const k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
